module.exports = __webpack_public_path__ + "img/smartLighting.adaa14b8.svg";